export default __webpack_public_path__ + "static/media/mastercard.f4aff5c9.svg";